export const BASE_CLINIC_PATH = '/clinics';
export const EDIT_CLINIC_PATH = `${BASE_CLINIC_PATH}/edit/:id`;